import Emptyfile1 from "../assets/svg/Emptyfile1.svg";
import {  useParams } from "react-router";
import AssignStuffToVan from "./Modals/AssignStuffToVan";
import { useState, useEffect } from "react";
import StuffImg from "../assets/svg/defultImage.svg";
import TransfereStuffModal from "./Modals/TransfereStuffModal";
import axios from "axios";
import { VEHICLE_ASSIGNS } from "../URLs/Apis";
import { useSelector } from "react-redux";
import "../pages/Vehicles/Vehicles.css";
import { Add, Search } from "@mui/icons-material";
import { newImageUrl } from "../pages/Manufacturers/ManufactureProfile";
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import DeleteModal from "./Modals/DeleteModal";
import { toast } from "react-toastify";
import transferImg from "../assets/svg/Staff Transfer.svg"

const StaffVans = ({getVehicleById}) => {

  const { user } = useSelector((state) => state.auth);
  const TOKEN = "Bearer " + user?.token;
  const {id : vanId} = useParams()
  const [show, setShow] = useState(false);
  const [selectVanModal, setSelectVanModal] = useState(false);
  const [selectedStuff, setSelectedStuff] = useState(false);
  const [stuffId, setStuffId] = useState([]);
  const [jobTitleId, setJobTitleId] = useState("");
  const [checkStuff, setCheckStuff] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [isAssignToCurrentVehicle, setIsAssignToCurrentVehicle] = useState([]);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleTransfereStuffModalShow = (staff) => {
    setStuffId(staff.id)
    setSelectVanModal(true);
  };
  
  const handleStuffCard = (checked, stuff) => {
   setCheckStuff((prev)=> [...prev , stuff])
    console.log(stuff);
  };

  const handleRevokeStaff = ()=>{
    if(checkStuff.length > 0){
      setShowDelete(true)
    }else{
    setSelectedStuff(true);
    }
  }

  const handleTransfereStuffModalClose = () => {
   setSelectVanModal(false);
  };

  const [vehicleStuff, setVehicleStuff] = useState([]);

  const getStuffVehicle = async () => {
    try {
      const response = await axios.get(
        `${VEHICLE_ASSIGNS}/${vanId}/staffs`,
        {
          headers: { Authorization: TOKEN },
        }
      );
      setVehicleStuff(response.data.data.vehicle_stuffs);
      console.log("staffff", response.data.data.vehicle_stuffs.map((staff)=> staff.current_vehicle.id
      ))
      const assignToCurrentVehicle = response.data.data.vehicle_stuffs.map((staff)=> staff.current_vehicle.id)
      setIsAssignToCurrentVehicle(assignToCurrentVehicle)
    } catch (error) {
      console.log(error);
    }
  };

  const 
  handleDeleteClose = () => {
    setShowDelete(false);
    setSelectedStuff(false)
    setCheckStuff([])
  };

  const RevokeStuffFromVan = async () => {
      const formData = new FormData();
    checkStuff.forEach((staff, index) => {
      formData.append(`revocations[${index}][stuff_id]`, staff.id);
      formData.append(
        `revocations[${index}][job_title_id]`,
        staff.job_title?.id || ""
      );
    });
    try {
      const response = await axios.post(`${VEHICLE_ASSIGNS}/${vanId}/staffs/bulk-revoke`,
        formData, {
        headers: {
          Authorization: TOKEN,
        }
      });
       toast.success(response.data.data.message);
      
      handleDeleteClose();
      getStuffVehicle();
      getVehicleById()
      console.log(response);
    } catch (error) {
      error.response.data?.errors?.data?.failed?.forEach((fail) => {
        toast.error(fail.message)})
         error.response.data?.errors?.data?.successful?.forEach((success) => {
          toast.success(success.message)})
      getStuffVehicle()
      handleDeleteClose()
    }
  };
  
  useEffect(() => {
    getStuffVehicle();
  }, []);

  return (
    <>
      <div>
          <DeleteModal
        showDelete={showDelete}
        handleDeleteClose={handleDeleteClose}
        textMessage={
          "Are you sure you want to delete this person ? Confirm to proceed or cancel to keep them."
        }
        deleteFunction={RevokeStuffFromVan}
      />
        <AssignStuffToVan getVehicleById={getVehicleById} show={show} handleClose={handleClose} getStuffVehicle={getStuffVehicle} isAssignToCurrentVehicle={isAssignToCurrentVehicle} />
        <TransfereStuffModal
          handleTransfereStuffModalClose={handleTransfereStuffModalClose}
          vehicleStuff={vehicleStuff}
          stuffId={stuffId}
          jobTitleId={jobTitleId}
          setSelectVanModal={setSelectVanModal}
          selectVanModal={selectVanModal}
          getStuffVehicle={getStuffVehicle}
          getVehicleById={getVehicleById}
        />

        <div className="container">
          <div
            className="card p-3 my-3 col-md-12  "
            style={{ border: "2px solid #EAEAEA " }}
          >
            <div className="card-body p-2 sm:p-1  ">
              <div className="d-flex align-items-center justify-content-between custom-card-sm ">
              <div
                  className="input-group flex-nowrap  justify-content-end align-items-center rounded-2 w-25 "
                >
                  <input
                    type="text"
                    className={
                      "form-control  bg-transparent position-relative rounded "
                    }
                    placeholder={"Search"}
                    aria-label="Username"
                    aria-describedby="addon-wrapping"
                  />
                   <div className="position-absolute mx-2">
                    <Search/>
                   </div>
                  
                </div>
               
                 <div className="d-flex align-items-center gap-3 button-responsive ">
                   <button onClick={handleRevokeStaff} className="btn btn-light px-2  "> 
                    <RemoveCircleOutlineOutlinedIcon sx={{marginInline:"3px" , color:"#A80101"}}/>
                    Remove
                    </button>
                   <button onClick={handleShow} className="btn btn-light"> 
                    <Add sx={{marginInline:"3px" }}/>
                    Add Staff</button>
                </div>

              </div>
              {vehicleStuff.length > 0 ? (
                <div className="min-vh-100  my-5 row">
                  {vehicleStuff.map((stuff) => (
                         <div key={stuff} className="col-12 col-lg-4 col-sm-12 position-relative">
                             <div className="position-absolute display-checkboxes">
                             {selectedStuff && (
                              <input
                                type="checkbox"
                                onChange={(e) => handleStuffCard(e.target.checked, stuff)}
                              />
                            )}
                        </div>
                      <div style={{overflow:"hidden"}} className="rounded-2 card px-3 py-2 bg-light my-2 custom-hight-mobile">
                        <div className="d-flex justify-content-between align-items-center my-1 custom-card-sm">
                          <h6 className="btn btn-dark rounded-5 text-white">
                            {stuff.job_title?.slug ? stuff.job_title?.slug : 'Staff' }
                          </h6>
                            <div className="cursor" onClick={() => handleTransfereStuffModalShow(stuff)}>
                              <img src={transferImg} alt="" />
                            </div>
                        </div>
                        <div className="d-flex justify-content-center align-items-center w-100 custom-hight-img-card">
                          <img
                            src={stuff.profile_photo_path ? `${newImageUrl}${stuff.profile_photo_path}` : StuffImg}
                            alt="stuff-img"
                            className="img-fluid"
                            style={{ maxHeight: "100%", maxWidth: "100%", objectFit: "fill" }}
                          />
                        </div>
                        <h6 className="fw-bold text-center my-1 label-size">
                          {stuff.first_name + " " + stuff.last_name}
                        </h6>
                        <div className="d-flex justify-content-between custom-card-sm mt-1">
                          <h6 className="text-secondary my-1 label-size">Joined in</h6>
                          <h6 className="text-black label-size my-1">{new Date(stuff.joined_at).toLocaleDateString()}</h6>
                        </div>
                        <div className="d-flex  justify-content-between custom-card-sm mt-1">
                          <h6 className="text-secondary my-1 label-size">Mobile Number</h6>
                          <h6 className="text-black label-size my-2">{stuff.phone_number}</h6>
                        </div>
                        <div className="d-flex justify-content-between custom-card-sm mt-1">
                          <h6 className="text-secondary my-1 label-size">Birth date</h6>
                          <h6 className="text-black my-1 label-size">{new Date(stuff.birth_date).toLocaleDateString()}</h6>
                        </div>
                        <div className="d-flex  justify-content-between custom-card-sm mt-1">
                          <h6 className="text-secondary my-1 label-size">Gender</h6>
                          <h6 className="text-black my-1 label-size">{stuff.gender}</h6>
                        </div>
                        <div className="d-flex justify-content-between custom-card-sm mt-1">
                          <h6 className="text-secondary my-1 label-size">Username</h6>
                          <h6 className="text-black my-1 label-size">{stuff.username}</h6>
                        </div>
                        <div className="d-flex justify-content-between custom-card-sm mt-1">
                          <h6 className="text-secondary my-1 label-size">Email</h6>
                          <h6 className="text-black my-1 label-size ">{stuff.email}</h6>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className=" d-flex  flex-column  align-items-center justify-content-center vh-100 ">
                  <div className=" text-center ">
                    <div>
                      <img
                        src={Emptyfile1}
                        className="img-fluid "
                        alt="No Staff"
                      />
                    </div>
                    <div className="lh-lg StaffStyle ">
                      <div>No staff assigned yet.</div>
                      <div>Add staff to this van to get started.</div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default StaffVans;
